import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Catalog = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Catalog' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M5,6 L1,4.5 L1,18.443038 L12,23 L23,18.443038 L23,4 L19,6 M5,16 L5,2 L12,5 L19,2 L19,16 L12,19 L5,16 Z M11.95,5 L11.95,19' />
  </StyledIcon>
);
